<template>
  <lateral-modal
    :title="$t('FILTERS')"
    @close="closeModal"
  >
    <template slot="extraAction">
      <div
        class="Link Link--action"
        @click="reset"
        v-t.preserve="{path:'ACTION_CLEAR'}"
      ></div>
    </template>
    <template slot="content">
      <form class="Form px-2">
        <div class="row
        ">
          <div class="col-12 ">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label"> {{$t('user_list_table_header_invited_on').toUpperCase()}}</label>
              <date-picker-input
                :value="invitedOnRange"
                :placeholder="'date_picker_input_transaction_date_range_selector'"
                @input="setDate"
                isRange
                :maxDate="new Date()"
              ></date-picker-input>
            </div>
          </div>
        </div>
        <div class="row">

          <div class="col-12">
            <div class="input--block  input--block--margin input--block--padded">
              <label
                for=""
                class="form--label"
              >{{$t('users_physical_card_status').toUpperCase()}}</label>
              <div class="multiselect-filter">
                <multi-select-input
                  :options="cardStatusList"
                  :placeholder="$t('users_physical_card_status')"
                  :customLabelField="'code'"
                  :value="physicalCardStatusId"
                  @inputSelected="setField('physicalCardStatusId', $event)"
                  translateLabel
                  :translateLabelAdditionalKey="'card_status__'"
                  :id="'card-status-select'"
                ></multi-select-input>
              </div>
            </div>
          </div>

        </div>
        <div class="row">

          <div class="col-12">
            <div class="input--block  input--block--margin input--block--padded">
              <label
                for=""
                class="form--label"
              >{{$t('STATUS').toUpperCase()}}</label>
              <div class="multiselect-filter">
                <multi-select-input
                  :options="userStatusList"
                  :placeholder="$t('STATUS')"
                  :value="membershipStatusId"
                  :customLabelField="'code'"
                  @inputSelected="setField('membershipStatusId', $event)"
                  translateLabel
                  :translateLabelAdditionalKey="'user_status__'"
                  :id="'membership-status-select'"
                ></multi-select-input>
              </div>

            </div>
          </div>
        </div>
      </form>
    </template>
    <template slot="footer">
      <a
        class="Button Button--primary flex-grow-1"
        href="#"
        @click.prevent="setFilters"
        v-t.preserve="{path: 'ACTION_FILTER'}"
      ></a>
    </template>
  </lateral-modal>
</template>

<script>
import { USER_TYPES } from '../../_constants/userTypes'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import LateralModal from '@/components/Commons/Modals/LateralModal'

function initialDataState () {
  return {
    invitedOnRange: null,
    physicalCardStatusId: '',
    membershipStatusId: ''
  }
}
export default {
  name: 'UserFilterModal',
  mixins: [_modalHandlerMixin],
  components: {
    DatePickerInput,
    MultiSelectInput,
    LateralModal
  },
  data () {
    return initialDataState()
  },
  methods: {
    reset () {
      Object.assign(this.$data, initialDataState())
      this.$emit('resetUsersFilters')
    },
    setDate (event) {
      this.invitedOnRange = event.defaultDate
    },
    setField (field, event) {
      if (event && event.target && event.target.value) {
        this[field] = event.target.value
      } else {
        this[field] = event
      }
    },
    async setFilters () {
      let filters = {}
      if (this.invitedOnRange && this.invitedOnRange.start) {
        filters['createdAt[after]'] = this.invitedOnRange.start
      }
      if (this.invitedOnRange && this.invitedOnRange.end) {
        filters['createdAt[before]'] = this.invitedOnRange.end
      }
      if (this.physicalCardStatusId) {
        filters['physicalCardStatusId'] = this.physicalCardStatusId
      }
      if (this.membershipStatusId) {
        filters['status.statusType.code'] = undefined
        filters['status.statusType.id'] = this.membershipStatusId
      } else {
        filters['status.statusType.code'] = [USER_TYPES.ACTIVE, USER_TYPES.INVITE_BY_ADMIN, USER_TYPES.INVITE_BY_SUPERADMIN]
      }
      await this.$store.dispatch('UsersStore/addUsersFilters', filters)
      this.closeModal()
    }
  },
  computed: {
    privateConfig () {
      return this.$store.getters['ConfigStore/privateConfig']
    },
    userStatusList () {
      return this.privateConfig && this.privateConfig.user_status_types ? this.privateConfig.user_status_types.filter(el => el.code !== USER_TYPES.INVITE_BY_SUPER_ADMIN && el.code !== USER_TYPES.ARCHIVE && el.code !== USER_TYPES.DELETED) : []
    },
    cardStatusList () {
      return this.privateConfig && this.privateConfig.card_statuses ? this.$store.getters['ConfigStore/privateConfig'].card_statuses : []
    }

  }
}
</script>

<style>
.Link {
  cursor: pointer;
}
</style>
